import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import * as HelperFunctions from '../../common/functions/helperFunctions';

const disposalPlacesList = (props) => {

    return (
        <DataTable
            value={props.disposalPlaces}
            paginator={true}
            lazy={true}
            rows={props.rows}
            totalRecords={props.totalRecords}
            onPage={(event) => props.onPageClick(event)}
            first={props.first}
            dataKey='disposalPlaceId'
        //loading={props.isLoading}	
        >
            <Column header="City"
                body={(rowData, column) =>
                    rowData && rowData.disposalPlacesContent && rowData.disposalPlacesContent.length ?
                        rowData.disposalPlacesContent
                            .filter(x => typeof x.city === 'string' && x.city.length > 0)
                            .map(r => r.city)
                            .join(' / ')
                        : null
                } />
            <Column header="Region"
                body={(rowData, column) =>
                    rowData && rowData.disposalPlacesContent && rowData.disposalPlacesContent.length ?
                        rowData.disposalPlacesContent
                            .filter(x => typeof x.region === 'string' && x.region.length > 0)
                            .map(r => r.region)
                            .join(' / ')
                        : null
                } />
            <Column header="Address"
                body={(rowData, column) =>
                    rowData && rowData.disposalPlacesContent && rowData.disposalPlacesContent.length ?
                        rowData.disposalPlacesContent
                            .filter(x => typeof x.address === 'string' && x.address.length > 0)
                            .map(r => r.address)
                            .join(' / ')
                        : null
                } />

            <Column
                field="date"
                header="Date"
                body={(rowData, column) =>
                    <div>
                        {rowData.date ? HelperFunctions.fomatDateAsString(new Date(rowData.date)) : ""}
                    </div>
                }
            />
            <Column field="interval" header="Interval" />
            <Column field="latitude" header="Latitude" />
            <Column field="longtitude" header="Longtitude" />
            <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                    <div>
                        <Button
                            type="button"
                            icon="pi pi-pencil"
                            className="p-button-warning"
                            tooltip="Edit"
                            tooltipOptions={{ position: 'top' }}
                            style={{ marginRight: ".5em" }}
                            onClick={() => props.editClick(rowData.disposalPlaceId)}
                        />
                        <Button
                            type="button"
                            icon="pi pi-trash"
                            className="p-button-danger"
                            tooltip="Delete"
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => props.deleteClick(rowData.disposalPlaceId)}
                        />
                    </div>
                }
            />
        </DataTable>
    )
}

export default disposalPlacesList;
